import classNames from "classnames"
import React from "react"

type Props = React.HtmlHTMLAttributes<"span">

export function Tag(props: Props) {

  return <span className={classNames("box-border text-xs leading-5 pt-[1px] ps-2 pe-2 border border-solid border-[#d9d9d9] rounded", props.className)}  >
    {props.children}
  </span>


}